import React from 'react';
import { Text, Flex, Box } from '@goodrx/matisse';

export const SectionTitle = ({ children, withDivider, ...props }: any) =>
  withDivider ? (
    <Flex alignItems="center" mb={3}>
      <Text fontSize={14} fontWeight={500}>
        {children}
      </Text>

      <Box bg="greyLight" height="1px" flex={1} ml={2} />
    </Flex>
  ) : (
    <Text as="h2" fontWeight={600} fontSize={18} {...props} mt={0} mb="12px" {...props}>
      {children}
    </Text>
  );
